import {createFileRoute, redirect} from '@tanstack/react-router';
import WorkList from '@/practitioner/views/diagnosticReport/WorkList';
import {AppRouterContext} from '@/shared/routing';
import {USER_HOME} from '@/shared/routing/paths';

export const Route = createFileRoute('/(practitioner)/practitioner/work-list')({
  component: WorkList,
  beforeLoad: function ({context}: {context: AppRouterContext}) {
    if (context.company?.isForClinicalTrials) {
      throw redirect({to: USER_HOME, replace: true});
    }
  }
});
